/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PostBulkBillingReportsZipRequestBodyTypename = "PostBulkBillingReportsZipRequestBody" as const;

/**
 *
 * @export
 * @interface PostBulkBillingReportsZipRequestBody
 */
export interface PostBulkBillingReportsZipRequestBody {
  /**
   * chain ids to generate. all bulk billing target chains if omitted or empty. must be a subset of the target chains
   * @type {Array<number>}
   * @memberof PostBulkBillingReportsZipRequestBody
   */
  chainIds?: Array<number>;
  /**
   * billing month (YYYYMM)
   * @type {string}
   * @memberof PostBulkBillingReportsZipRequestBody
   */
  month: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostBulkBillingReportsZipRequestBody
   */
  readonly __typename?: string;
}

export function PostBulkBillingReportsZipRequestBodyFromJSON(json: any): PostBulkBillingReportsZipRequestBody {
  return PostBulkBillingReportsZipRequestBodyFromJSONTyped(json, false);
}

export function PostBulkBillingReportsZipRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostBulkBillingReportsZipRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostBulkBillingReportsZipRequestBodyTypename,

    chainIds: !exists(json, "chain_ids") ? undefined : json["chain_ids"],
    month: json["month"],
  };
}

export function PostBulkBillingReportsZipRequestBodyToJSON(object?: PostBulkBillingReportsZipRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    chain_ids: value.chainIds,
    month: value.month,
  };
}
